import payrollCycle from '@/api/hr/payroll-cycle'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  months: [
    {
      value: 1,
      text: 'January'
    },
    {
      value: 2,
      text: 'February'
    },
    {
      value: 3,
      text: 'March'
    },
    {
      value: 4,
      text: 'April'
    },
    {
      value: 5,
      text: 'May'
    },
    {
      value: 6,
      text: 'June'
    },
    {
      value: 7,
      text: 'July'
    },
    {
      value: 8,
      text: 'August'
    },
    {
      value: 9,
      text: 'September'
    },
    {
      value: 10,
      text: 'October'
    },
    {
      value: 11,
      text: 'November'
    },
    {
      value: 12,
      text: 'December'
    }
  ]
}

export const getters = {
  getMonth: state => month => {
    let result = state.months.filter(m => m.value === parseInt(month))
    return result.length > 0 ? result[0].text : ''
  }
}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return payrollCycle.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return payrollCycle.store(data)
  },

  update(context, { id, data }) {
    return payrollCycle.update(id, data)
  },

  release(context, id) {
    return payrollCycle.release(id).then(response => {
      return Promise.resolve(response)
    })
  }
}
